/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../components/auth/auth-constants';
import {InvoiceTranslationResource} from '../../components/api/resources/resource/invoice-translation.resource';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-invoice-translation-route-page',
  template: `
    <adn-invoice-translation-list-page
      *ngIf="list"
      [list]="list">
    </adn-invoice-translation-list-page>
  `
})
export class InvoiceTranslationRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(InvoiceTranslationResource) private readonly InvoiceTranslation: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageReportTemplates.apiKey);

    this.adnListHelper.setUpList(this.list, this.InvoiceTranslation, readOnly, 'fullInvoiceTranslationList', {
      baseTable: 'invoiceTranslation'
    });
  }
}
